import { jsx, jsxs } from "react/jsx-runtime";
import React__default from "react";
import classNames from "classnames";
import { AnalyticsId, IconSize } from "../../constants.js";
import { useBreakpoint, Breakpoint } from "../../hooks/useBreakpoint.js";
import { useHover } from "../../hooks/useHover.js";
import { getColor } from "../../theme/currys/color.js";
import { I as Icon } from "../../Icon.js";
import ArrowRight from "../Icons/ArrowRight.js";
import ArrowUpRight from "../Icons/ArrowUpRight.js";
import { L as LazyIllustration } from "../../LazyIllustration.js";
import { T as Title } from "../../Title.js";
import styles from "./styles.module.scss";
const PromoPanelLink = (props) => {
  if (props.linkComponent) {
    return React__default.cloneElement(props.linkComponent, { children: props.children });
  }
  if (props.linkHtmlMarkup === "button") {
    return /* @__PURE__ */ jsx("button", { type: "button", onClick: props.linkOnClick, children: props.children });
  }
  return /* @__PURE__ */ jsx("a", { href: props.href, target: props.target, onClick: props.linkOnClick, children: props.children });
};
const PromoPanel = (props) => {
  const { isHovered, hoverRef } = useHover();
  const { color = "neutral", titleHtmlMarkup = "h2", linkHtmlMarkup = "a" } = props;
  const breakpoint = useBreakpoint();
  const promoPanelClasses = classNames(
    styles.promopanel,
    styles[`promopanel--${color}`],
    !props.illustration && styles["promopanel--no-illustration"]
  );
  const promoPanelLink = /* @__PURE__ */ jsx(
    PromoPanelLink,
    {
      href: props.href,
      target: props.target,
      linkComponent: props.linkComponent,
      linkHtmlMarkup,
      linkOnClick: props.linkOnClick,
      children: props.title || props.children
    }
  );
  const illustrationSize = (() => {
    if (breakpoint >= Breakpoint.md) {
      return 156;
    }
    return 110;
  })();
  return /* @__PURE__ */ jsxs("div", { className: promoPanelClasses, "data-testid": props.testId, "data-analyticsid": AnalyticsId.PromoPanel, ref: hoverRef, children: [
    props.illustration && /* @__PURE__ */ jsx(
      LazyIllustration,
      {
        illustrationName: props.illustration,
        size: illustrationSize,
        color,
        className: styles.promopanel__illustration
      }
    ),
    /* @__PURE__ */ jsxs("div", { className: styles.promopanel__content, children: [
      props.title && /* @__PURE__ */ jsx(Title, { htmlMarkup: titleHtmlMarkup, appearance: "title3", children: promoPanelLink }),
      !props.title ? promoPanelLink : props.children
    ] }),
    /* @__PURE__ */ jsx(
      Icon,
      {
        className: styles.promopanel__icon,
        svgIcon: props.target === "_blank" ? ArrowUpRight : ArrowRight,
        size: breakpoint >= Breakpoint.md ? IconSize.Small : IconSize.XSmall,
        isHovered,
        color: getColor("blueberry", 500),
        hoverColor: getColor("blueberry", 600)
      }
    )
  ] });
};
export {
  PromoPanel as default
};
//# sourceMappingURL=index.js.map
